import { useNotificationContext } from '@modules/common/components/Notification/NotificationContext';
import { DashboardLayout } from '@modules/dashboard/components/DashboardContents/DashboardLayout';
import { useFetchDashboard } from '@modules/dashboard/hooks';
import { DashboardActionType } from '@modules/dashboard/store/dashboardActionType';
import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import { Box, Skeleton, Stack, Typography } from '@mui/material';
import { DashboardListItemViewFragment } from 'generated/graphql';
import { useEffect } from 'react';

interface CreateNewDashboardTemplatePreviewContentProps {
  selectedTemplate: DashboardListItemViewFragment;
}

export const CreateNewDashboardTemplatePreviewContent = ({
  selectedTemplate,
}: CreateNewDashboardTemplatePreviewContentProps) => {
  const {
    dashboard: template,
    loading,
    error,
  } = useFetchDashboard({
    token: selectedTemplate.viewToken,
  });
  const dispatch = useDashboardStore(({ dispatch }) => dispatch);

  useEffect(() => {
    return () => {
      dispatch({
        type: DashboardActionType.RESET,
      });
    };
  }, [dispatch, selectedTemplate.id]);

  const { showErrorNotification } = useNotificationContext();

  useEffect(() => {
    if (error) {
      showErrorNotification({
        contentComponent: 'Failed to get templates list',
        props: {},
      });
    }
  }, [error, showErrorNotification]);

  return (
    <Stack key={selectedTemplate.viewToken} spacing={4} height="100%">
      <Box px={6}>
        {template ? (
          <Typography variant="subtitle1">{template.description}</Typography>
        ) : (
          <Skeleton variant="text" width="100%" height={40} />
        )}
      </Box>
      <Box px={'2vw'} pb={2} height="100%" overflow="auto">
        <DashboardLayout
          shouldHideHeader={true}
          shouldHideSaveToDashboardButton
          isLoading={loading}
        />
      </Box>
    </Stack>
  );
};
